import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "tutorial-wrapper" }
const _hoisted_2 = { class: "tutorial-text" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = { class: "tutorial-bg" }
const _hoisted_5 = ["alt", "src"]
const _hoisted_6 = { class: "tutorial-action-btns d-flex justify-content-center h-90" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.tutorialData[_ctx.currentIndex].label), 1 /* TEXT */),
      _createElementVNode("div", null, _toDisplayString(_ctx.tutorialData[_ctx.currentIndex].description), 1 /* TEXT */)
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("img", {
        class: "tutorial-img",
        alt: _ctx.tutorialData[_ctx.currentIndex].label,
        src: _ctx.tutorialData[_ctx.currentIndex].icon
      }, null, 8 /* PROPS */, _hoisted_5)
    ]),
    _createElementVNode("footer", _hoisted_6, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-light border border-secondary me-2 w-30 skip-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSkipTutorial()))
      }, " Skip "),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary border border-primary w-30 next-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleNext()))
      }, _toDisplayString(_ctx.currentIndex === _ctx.tutorialData.length - 1 ? "Finish" : "Next"), 1 /* TEXT */)
    ])
  ]))
}